import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/hangover-3-mobile.png'
import _imports_1 from '@/assets/images/hangover-4-pc.png'


const _withScopeId = n => (_pushScopeId("data-v-fc749bb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column fill-height justify-center align-center text-white" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-h4 font-weight-thin mb-4 mainheader" }, "Hangover-Lounge"),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-h4 font-weight-thin mb-4 subheading" }, " \"Willkommen in einer der ersten Shisha-Bars in Ludwigsburg!\" ")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column fill-height justify-center align-center text-white" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-h4 font-weight-thin mb-4 mainheader" }, "Hangover-Lounge"),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-h4 font-weight-thin mb-4 subheading" }, " \"Willkommen in einer der ersten Shisha-Bars in Ludwigsburg!\" ")
], -1))
const _hoisted_3 = { id: "galerie" }
const _hoisted_4 = { class: "mt-10 mb-3" }
const _hoisted_5 = { class: "mt-10 mb-3" }
const _hoisted_6 = {
  id: "kontakt",
  class: "footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_parallax = _resolveComponent("v-parallax")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_ShishaProducts = _resolveComponent("ShishaProducts")!
  const _component_DrinkProducts = _resolveComponent("DrinkProducts")!
  const _component_OpeningHoursCard = _resolveComponent("OpeningHoursCard")!
  const _component_MapsComponent = _resolveComponent("MapsComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isDesktop())
      ? (_openBlock(), _createBlock(_component_v_parallax, {
          key: 0,
          height: _ctx.deviceHeight() - 50,
          src: _imports_0
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["height"]))
      : (_openBlock(), _createBlock(_component_v_parallax, {
          key: 1,
          height: _ctx.deviceHeight() - 50,
          src: _imports_1
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["height"])),
    _createElementVNode("div", null, [
      _createVNode(_component_v_divider, {
        thickness: "1",
        color: "#660066"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_carousel, {
        ref: "galerie",
        height: _ctx.deviceHeight() - 180,
        "hide-delimiters": "",
        cycle: _ctx.isDesktop()
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
            return (_openBlock(), _createBlock(_component_v_carousel_item, {
              key: image,
              src: image,
              cover: ""
            }, null, 8, ["src"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["height", "cycle"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_divider, {
        thickness: "6",
        inset: "",
        color: "black"
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ productColumns: _ctx.isDesktop(), mobile: !_ctx.isDesktop() })
    }, [
      _createVNode(_component_ShishaProducts, { id: "shishas" }),
      _createVNode(_component_DrinkProducts, { id: "getraenke" })
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_divider, {
        thickness: "6",
        inset: "",
        color: "black"
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_OpeningHoursCard, { ref: "kontakt" }, null, 512),
      (_ctx.isDesktop())
        ? (_openBlock(), _createBlock(_component_MapsComponent, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}